var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.noData)?_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('noData')))]):_vm._e(),_c('AutoRow',{attrs:{"data":[
    {
      text: '新增用户数',
      value: _vm.data.new_users_count,
      to: { name: 'users.index' },
    }, {
      text: '用户总数',
      value: _vm.data.users_count,
      to: { name: 'users.index' },
    }, {
      text: '新增图片任务',
      value: _vm.data.new_images_count,
      to: { name: 'images.index' },
    }, {
      text: '图片任务总数',
      value: _vm.data.images_count,
      to: { name: 'images.index' },
    }
  ]}}),_c('AutoChartRow',{attrs:{"data":[
    {
      text: '用户趋势折线图',
      options: _vm.newUsersTrendLineOptions,
    }, {
      text: '图片任务趋势折线图',
      options: _vm.newImagesTrendLineOptions,
    }
  ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }